export default __webpack_public_path__ + "static/media/JP4-1.9edab944.jpg";